import { Navigate, useParams } from "react-router-dom";
import { SEO_PAGE_TYPES } from "../../constants/seoPageConstants";
import { getSeoPageConfig } from "../../services/seoPageService";
import { normalizeDealerSlug } from "../../utils/dealerProfile";
import SeoLandingPage from "./SeoLandingPage";

/**
 * Legacy `/concesionarios/:slug` — city SEO pages stay put; dealer profiles redirect to runtime.
 */
export default function ConcesionariosLegacySlugRoute() {
  const { dealerSlug } = useParams();
  const normalized = normalizeDealerSlug(dealerSlug);
  const seoConfig = normalized ? getSeoPageConfig(`/concesionarios/${normalized}`) : null;

  if (seoConfig?.pageType === SEO_PAGE_TYPES.DEALER_CITY) {
    return <SeoLandingPage />;
  }

  const targetSlug = normalized || dealerSlug;
  if (!targetSlug) {
    return <Navigate to="/v/automap/concesionarios" replace />;
  }

  return (
    <Navigate to={`/v/automap/concesionarios/${encodeURIComponent(targetSlug)}`} replace />
  );
}
